import AdminResetNotice from "./component/AdminResetNotice";

// Self-service reset is off for admins; see AdminResetNotice.
const ResetPassword = () => <AdminResetNotice title="Reset your password" />;

export default ResetPassword;
